import { render, staticRenderFns } from "./notAccess.vue?vue&type=template&id=4d927efa"
import script from "./notAccess.vue?vue&type=script&lang=js"
export * from "./notAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports